var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c(_vm.page,{tag:"component",attrs:{"amount":_vm.limitAmount,"uuid":_vm.uuid},on:{"update:amount":function($event){_vm.limitAmount=$event},"update:uuid":function($event){_vm.uuid=$event},"reset":_vm.resetForm}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }